<template>
  <v-dialog v-model="transactionsModal" persistent width="500">
    <v-card tile>
      <v-card-title class="headline">{{
          $t("transactionsAccountTopUp")
        }}</v-card-title>
      <v-card-text>
        <v-text-field
          :label="$t('transactionsAmount') + ' *'"
          dense
          type="number"
          required
          v-model="amount"
          :error-messages="transactionAmountErrors"
          @input="$v.amount.$touch()"
          @blur="$v.amount.$touch()"
        >
          <template v-slot:prepend-inner>
            <span class="currency" v-if="location.currency && location.currency.is_before" v-html="location.currency.code"></span>
          </template>
          <template v-slot:append>
            <span class="currency" v-if="location.currency && !location.currency.is_before" v-html="location.currency.code"></span>
          </template>
        </v-text-field>
        <small>* {{ $t("validation") }}</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closeForm()">{{
          $t("btnExit")
        }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="submitForm()"
          :disabled="$v.amount.$invalid"
          >{{ $t("btnPay") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  name: "transactionsAccountModal",

  mixins: [validationMixin],

  props: ["transactionsModal", "selectedLocation"],

  data() {
    return {
      amount: null,
    };
  },

  validations: {
    amount: {
      required,
      maxLength: maxLength(8),
    },
  },

  computed: {
    ...mapGetters(["location"]),
    transactionAmountErrors() {
      const errors = [];
      if (!this.$v.amount.$dirty) return errors;
      !this.$v.amount.required &&
        errors.push(this.$i18n.t("validationSum"));
      !this.$v.amount.maxLength &&
        errors.push(this.$i18n.t("validationPaymentsLength"));
      return errors;
    },
  },

  methods: {
    ...mapActions(["refillLocationAccount"]),
    submitForm() {
      this.refillLocationAccount({amount: this.amount}).then((response) => {
        window.location.href = response.data.payment_url
        this.closeForm()
      });
    },
    closeForm() {
      this.amount = null
      this.$v.$reset()
      this.$emit("close-dialog");
    },
  },
};
</script>

<style>
.currency {
  color: black !important;
  font-size: 24px;
}
</style>
